<template>
  <ComponentsLayoutWithNavbar
    id="yc-market"
    class="yc-market"
    main_color="main__light_green"
    with_footer>
    <template #breadcrumbs>
      <TenderBreadcrumbs
        :new_tender="!tender.tenderId"/>
    </template>
    <template #main_content>
      <div class="width-100 mt-5">
        <StepNumber
          :disabled="!tender.tenderId"/>
      </div>
      <iframe
        ref="myIframe"
        class="youcontrol__iframe"
        sandbox="allow-same-origin allow-storage-access-by-user-activation allow-scripts allow-modals allow-popups allow-downloads allow-popups-to-escape-sandbox"
        :src="iframeHref"
        title="youcontrol"
        width="400"/>
    </template>
    <template #nav_bar="{ mini }">
      <div
        class="selected-members pa-0 pt-8 main__green">
        <sIcon
          v-if="!mini && loading"
          class="mx-auto"
          color="var(--secondary__green_not_active)"
          size="30"
          spin
          type="loading"/>
        <div
          v-else-if="!mini && !(companis && companis.length)"
          class="px-4">
          <div class="pl-2 pr-1 flex wrap h4-headline align-center">
            {{ $t('Tenders.NoAnyParticipants') }}
          </div>
          <div class="mt-3 pl-2 h6-text text-start">
            {{ $t('Tenders.findNecessarySupplierYC') }}
          </div>
        </div>
        <div
          v-else-if="!mini"
          class="px-2 main__green width-100"
          elevation="0">
          <div class="pl-2 flex wrap h4-headline py-2 pr-1">
            {{ $t('Common.Check') }}
            <span class="secondary__green_not_active--text ml-2 pt-1 h7-text-medium">{{ companis && companis.length ? companis.length : 0 }}</span>
            <sButton
              class="btn h11-links-bold ml-auto"
              :disabled="loading"
              icon="delete"
              small
              type="text"
              @click="deleteAll">
              {{ $t('Common.Clear') }}
            </sButton>
          </div>
          <CartList
            key-field="email"
            :list="companis">
            <template #item-title="{ item }">
              {{ item.email || '-' }}
            </template>
            <template #item-additional="{ item }">
              <div
                v-if="item.name">
                {{ item.name }}
              </div>
            </template>
            <template #item-action="{ item }">
              <sButton
                :disabled="loading"
                icon="delete"
                small
                type="green"
                @click="clickSelect(item, true)"/>
            </template>
          </CartList>
        </div>
      </div>
    </template>
    <template #footer>
      <div
        key="footer"
        class="width-100 text-right">
        <sButton
          data-qa="footer-button-next"
          :disabled="loading"
          :loading="loading"
          @click="goToNextStep">
          {{ $t('Common.Next') }}
        </sButton>
      </div>
    </template>
  </ComponentsLayoutWithNavbar>
</template>
<script>
import CartList from 'components/common/blocks/CartList.vue'
import StepNumber from 'components/common/elements/StepNumber.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'

import { mapGetters } from 'vuex'
import { storageMixin } from 'mixins'
import youcontrol from 'mixins/youcontrol.js'

export default {
  name: 'youcontrolStepPage',
  mixins: [ youcontrol, storageMixin ],
  data() {
    return {
      loading: false,
      companis: [],
    }
  },
  methods: {
    deleteAll() {
      this.companis = []
    },
    checkResultYoucontrol(props) {
      if (!props?.length) {
        return
      }
      const result = this.$_getUniqueEmails(props)
      this.companis = result.info
    },
    goToNextStep() {
      const info = this.$store.getters['getNewTenderInfo']
      info.step += 1
      this.$store.commit('setNewTenderInfo', info)
      this.$router.push({ query: {...this.$route.query, step: 2}})
    },
    clickSelect(item) {
      const index = this.companis.findIndex(i => i.email === item.email)
      if (index === -1) {
        return
      }
      this.companis.splice(index, 1)
    }
  },
  computed: {
    ...mapGetters({
      tender: 'getNewTender'
    }),
  },
  created() {
    try {
      this.companis = JSON.parse(this.$_getPropFromLocalStorage('youcontrolTender', [], true) || '[]')
    } catch {
      this.companis = []
    }
  },
  components: {
    CartList,
    StepNumber,
    TenderBreadcrumbs,
    ComponentsLayoutWithNavbar
  },
  watch: {
    companis: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.$_savePropToLocalStorage('youcontrolTender', JSON.stringify(newValue), true)
      }
    }
  },
}
</script>
<style lang="scss">
.yc-market .main-content {
  height: calc(100% - 74px);
}
</style>
<style scoped lang="scss">
.youcontrol__iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
.selected-members {
  height: 100%;
  width: 100%;
  align-items: end;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}
</style>
